// extracted by mini-css-extract-plugin
module.exports = {"loader":"Kb","smallLoader":"Lb","loading-keyframes":"Mb","pageLoader":"Nb","centered":"Ob","whitespacePlaceholder":"Pb","buttonSpinner":"Qb","fade-in":"Rb","rotate":"Sb"};